import React, { useEffect, useState } from "react";
import "./jobs.css";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";
import useAuth from "../../../hooks/useAuth";

function Jobs() {
  const [membersList, setMembersList] = useState([]);
  const [selectedMember, setSelectedMember] = useState("");
  const [loading, setLoading] = useState(false);
  const { organisation } = useAuth();

  useEffect(() => {
    fetchMemberList();
  }, [organisation._id]);

  const fetchMemberList = async () => {
    axiosInstance
      .get(`/api/member/${organisation._id}/getallminimalmembers`)
      .then((response) => {
        setMembersList(response.data);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to load members");
      });
  };

  const handleMemberChange = (event) => {
    setSelectedMember(event.target.value);
  };

  const handleGenerateInvoice = async () => {
    if (!selectedMember) {
      toast.error("Please select a member first");
      return;
    }

    setLoading(true);
    try {
      const response = await axiosInstance.post(
        `/api/jobs/${organisation._id}/trigger-invoice-generation`,
        { memberId: selectedMember }
      );
      toast.success("Invoice generation triggered successfully!");
      console.log(response.data);
      setSelectedMember("");
    } catch (error) {
      console.error(error);
      toast.error("Error triggering invoice generation");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="jobs-container">
      <div className="jobs-header">
        <h3 className="jobs-heading">Jobs</h3>
      </div>
      
      <div className="jobs-grid">
        <div className="job-card">
          <div className="job-card-header">
            <h4>Invoice Generation</h4>
          </div>
          <div className="job-card-body">
            <label htmlFor="member">Select Member:</label>
            <select
              id="member"
              value={selectedMember}
              onChange={handleMemberChange}
              className="jobs-select"
            >
              <option value="">Select Member</option>
              {membersList.map((member) => (
                <option key={member._id} value={member._id}>
                  {member.full_name}
                </option>
              ))}
            </select>
            
            <button
              className="jobs-submit-btn"
              onClick={handleGenerateInvoice}
              disabled={loading || !selectedMember}
            >
              {loading ? "Generating..." : "Generate Invoice"}
            </button>
          </div>
        </div>
        
        {/* Additional jobs can be added here in the future as separate cards */}
      </div>
    </div>
  );
}

export default Jobs;
